module.exports = __webpack_public_path__ + "static/media/20210212_192341_595_IMG_2044.dc64ad41.jpg";